import type { JSX } from 'react';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { SortableTableHeaders } from '@/shared/components/SortableTableHeaders';
import type { SortState } from '@/shared/types/table-filters.types';
import { CompanyUserRow } from './CompanyUserRow';
import type { CompanyUser } from '../types/company-admin.types';

export interface CompanyUsersTableProps {
  users: CompanyUser[];
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  currentUserId?: string | undefined;
  onEdit: (user: CompanyUser) => void;
}

const SORTABLE_HEADERS = [
  { key: 'fullName', label: 'User', className: 'w-[300px]' },
  { key: 'roles', label: 'Roles' },
  { key: 'isActive', label: 'Status' },
  { key: 'lastLoginAt', label: 'Last Login' },
];

export function CompanyUsersTable({
  users,
  sort,
  onToggleSort,
  currentUserId,
  onEdit,
}: CompanyUsersTableProps): JSX.Element {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <SortableTableHeaders
              headers={SORTABLE_HEADERS}
              sort={sort}
              onToggleSort={onToggleSort}
            />
            <TableHead className="w-[70px]">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((user) => (
            <CompanyUserRow
              key={user.id}
              user={user}
              currentUserId={currentUserId}
              onEdit={onEdit}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
